import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Swipe from 'swipejs';

var ReactSwipe = /*#__PURE__*/function (_Component) {
  _inherits(ReactSwipe, _Component);

  var _super = _createSuper(ReactSwipe);

  function ReactSwipe() {
    _classCallCheck(this, ReactSwipe);

    return _super.apply(this, arguments);
  }

  _createClass(ReactSwipe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.swipe = Swipe(this.containerEl, this.props.swipeOptions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          childCount = _this$props.childCount,
          swipeOptions = _this$props.swipeOptions;
      var shouldUpdateSwipeInstance = prevProps.childCount !== childCount || prevProps.swipeOptions != swipeOptions;

      if (shouldUpdateSwipeInstance) {
        this.swipe.kill();
        this.swipe = Swipe(this.containerEl, this.props.swipeOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.swipe.kill();
      this.swipe = void 0;
    }
  }, {
    key: "next",
    value: function next() {
      this.swipe.next();
    }
  }, {
    key: "prev",
    value: function prev() {
      this.swipe.prev();
    }
  }, {
    key: "slide",
    value: function slide() {
      var _this$swipe;

      (_this$swipe = this.swipe).slide.apply(_this$swipe, arguments);
    }
  }, {
    key: "getPos",
    value: function getPos() {
      return this.swipe.getPos();
    }
  }, {
    key: "getNumSlides",
    value: function getNumSlides() {
      return this.swipe.getNumSlides();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          className = _this$props2.className,
          style = _this$props2.style,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        ref: function ref(el) {
          return _this.containerEl = el;
        },
        className: "react-swipe-container ".concat(className),
        style: style.container
      }, /*#__PURE__*/React.createElement("div", {
        style: style.wrapper
      }, React.Children.map(children, function (child) {
        if (!child) {
          return null;
        }

        var childStyle = child.props.style ? _objectSpread(_objectSpread({}, style.child), child.props.style) : style.child;
        return /*#__PURE__*/React.cloneElement(child, {
          style: childStyle
        });
      })));
    }
  }]);

  return ReactSwipe;
}(Component);

_defineProperty(ReactSwipe, "propTypes", {
  swipeOptions: PropTypes.shape({
    startSlide: PropTypes.number,
    speed: PropTypes.number,
    auto: PropTypes.number,
    continuous: PropTypes.bool,
    disableScroll: PropTypes.bool,
    stopPropagation: PropTypes.bool,
    draggable: PropTypes.bool,
    swiping: PropTypes.func,
    callback: PropTypes.func,
    transitionEnd: PropTypes.func
  }),
  style: PropTypes.shape({
    container: PropTypes.object,
    wrapper: PropTypes.object,
    child: PropTypes.object
  }),
  id: PropTypes.string,
  className: PropTypes.string,
  childCount: PropTypes.number
});

_defineProperty(ReactSwipe, "defaultProps", {
  swipeOptions: {},
  style: {
    container: {
      overflow: 'hidden',
      visibility: 'hidden',
      position: 'relative',
      height: '100%'
    },
    wrapper: {
      overflow: 'hidden',
      position: 'relative',
      height: '100%',
      minHeight: '40vh'
    },
    child: {
      "float": 'left',
      width: '100%',
      position: 'relative',
      transitionProperty: 'transform'
    }
  },
  className: '',
  childCount: 0
});

export default ReactSwipe;